// extracted by mini-css-extract-plugin
module.exports = {"tickerTrack":"ticker_tickerTrack__eqrNh","tickerScroll":"ticker_tickerScroll__T8Cjn","tickerPaused":"ticker_tickerPaused__a9CwG"};